
import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, ObservableInput, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { ErrorsComponent } from '../main/errors/errors.component';
import { MatDialog } from '@angular/material/dialog';
import { DialogService } from '../services/dialog.service';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from '../services/auth.service';
import { AppSettings } from '../services/app.settings';
import moment from 'moment';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  constructor(private _router: Router,
    private dialogService: DialogService,
    private _dialog: MatDialog,
    private msalService: MsalService,
    private authService: AuthService,
    private appsettings: AppSettings) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (this.authService.isAuthenticated()) {
      req = req.clone({
        setHeaders: {
          Authorization: `Bearer ${this.authService.authInfo()?.accessToken}`,
          testRole: `${this.appsettings.testRole}`,
          version: `${this.appsettings.appVersion}`
        }
      });
     const transformedBody = this.convertDatesToUtc(req.body);
     req = req.clone({ body: transformedBody });
    }
    else {
      // Ohne bearer Token Request blockieren
      console.log('Request without bearer token blocked :' + req.url);
      return new Observable();
    }
    return next.handle(req).pipe(
      catchError((response: HttpErrorResponse): ObservableInput<any> => {
        if (response.status === 403) {
          this._router.navigateByUrl('/authorization');
          return throwError(() => new Error(response.message));

        } else if (response.status === 400 || response.status === 409) {
          this.dialogService.showInfoDialog(response.error, 'Fehler', 240);
        } else if (response.status === 401) {
          this.authService.setAuthInfo().then(() => {
          });
        } else if (response.status === 500) {
          let dialog = this._dialog.open(ErrorsComponent);
          dialog.componentInstance.errorMessage = response.message;
          if (response.error instanceof Blob) {
            var reader = new FileReader();
            reader.onload = function () {
              dialog.componentInstance.errorText = reader.result?.toString() ?? '';
            };
            reader.readAsText(response.error);
          } else {
            dialog.componentInstance.errorText = response.error;
          }
        }

        console.log(response);
        return throwError(() => new HttpErrorResponse({ error: response.error, headers: response.headers, status: response.status, statusText: response.statusText, url: response.url! }));
      }
      )
    );
    //})
  }

  private convertDatesToUtc(obj: any): any {
    if (!obj || typeof obj !== 'object' || obj instanceof FormData) return obj;

    const transformed: any = Array.isArray(obj) ? [] : {};

    for (const key of Object.keys(obj)) {
      const val = obj[key];
      if (val instanceof Date) {
        var diff =  val.getTimezoneOffset() * -1;
        transformed[key] =  moment(val).add(diff, "minutes"); 
      } else if (typeof val === 'object') {
        transformed[key] = this.convertDatesToUtc(val); // recursive
      } else {
        transformed[key] = val;
      }
    }

    return transformed;
  }

}
